
export const ACTIVIDADES_VALUE = "actividades"
export const PROFESORES_VALUE  = "profesor"

export const itemsSearch = [
    { value: ACTIVIDADES_VALUE, label: "Grupos de los colegios por Actividades"}, 
    { value: PROFESORES_VALUE,  label: "Grupos de los colegios por Profesores" }
]

export const itemsOrder  = {
    actividades: [
        { value: '{"registro_actividad.id_actividad": "ASC"}', label: "Actividades" }, 
        { value: '{"grupo_colegio.clave_grupo": "ASC"}',  label: "Clave de Grupo" }, 
        { value: '{"grupo_colegio.id": "ASC"}',           label: "Id. Grupo" }, 
    ],
    profesor: [
        { value: '{"empleado.apellido1": "ASC", "empleado.apellido2": "ASC", "empleado.nombre": "ASC"}', label: "Profesores" }
    ]
}